import DeviationVideo from './DeviationVideo';
import DeviationVideoContainer from './DeviationVideo.container';
export default DeviationVideoContainer(DeviationVideo);
//# sourceMappingURL=index.js.map